import React, { ComponentProps } from 'react';
import { Backdrop } from '@components/Backdrop/Backdrop.component';

import './Overlay.scss';

function Overlay({ visible, ...rest }: Omit<ComponentProps<typeof Backdrop>, 'open'> & { visible: boolean }) {
  return <Backdrop className="overlay" open={visible} {...rest} />;
}

export { Overlay };
